
import React from "react";
import "./PizzaLoader.css";

export default function PizzaLoader({
  size = 96,
  speedSec = 1.2,
  label = "Loading…",
}) {
  const slices = 8;
  const toppingsPerSlice = 1;

  return (
    <div
      className="pizza-loader"
      role="status"
      aria-label={label}
      title={label}
      style={{ "--size": `${size}px`, "--speed": `${speedSec}s` }}
    >
      <div className="pizza-container">
        {/* Create actual pizza slices */}
        {Array.from({ length: slices }).map((_, i) => (
          <div
            key={i}
            className="pizza-slice"
            style={{
              "--slice-index": i,
              "--rotation": `${i * 45}deg`,
              "--delay": `${i * 0.15}s`,
            }}
          >
            {/* Slice shape */}
            <div className="slice-wedge">
              {/* Pepperoni toppings on this slice */}
              {Array.from({ length: toppingsPerSlice }).map((_, j) => (
                <span
                  key={j}
                  className="slice-topping"
                  style={{
                    "--topping-position": `${30 + j * 20}%`,
                  }}
                />
              ))}
            </div>
          </div>
        ))}
        
        {/* Center pepperoni */}
        <div className="center-topping"></div>
      </div>
      <p className="pizza-label">{label}</p>
      <p>Processing... Please wait.</p>
    </div>
  );
}
